import { EventActionType } from './event-action-type';

export interface SetEventNameAction {
  eventKey: string;
  name: string;
  type: EventActionType.SetEventName;
}

export const setEventName = (
  eventKey: string,
  name: string,
): SetEventNameAction => ({
  eventKey,
  name,
  type: EventActionType.SetEventName,
});
